import { __awaiter } from "tslib";
import * as React from 'react';
import * as css from './ShoppingCart.css';
import Stepbar from '@websky/core/src/Checkout/components/Checkout/Stepbar/Stepbar';
import Step from '@websky/core/src/Stepbar/components/Step/Step';
import { useSelector } from 'react-redux';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import { ThemeProvider } from '@websky/core/src/theme';
import theme from '../../theme/theme';
import { OrderStatus } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { oneTwoTripSupplierLink } from '@websky/core/src/SearchForm/utils';
import { convertOrderToHotelsSupplierData } from './utils';
import { useConfig } from '@websky/core/src/context';
import SimpleLoader from '@websky/core/src/SimpleLoader';
const StepbarWithShoppingCart = props => {
    const order = useSelector(getOrder);
    const { t } = useTranslation('Stepbar');
    const [loading, setLoading] = React.useState(false);
    const { SearchForm: { offerHotelsLink, offerHotelsAdditionalId } } = useConfig();
    const redefinedTheme = {
        MobileStepbar: {
            MobileStepbarStyles: {
                header: css.mobileStepbar__header,
                expand: css.mobileStepbar__expand
            },
            StepContentStyles: {
                segment__header: css.stepContent__segmentHeader,
                segment__header_flights: css.stepContent__segmentFLights,
                footer: css.stepContent__footer
            }
        }
    };
    const stepsAmount = Object.keys(props.stepbarConfig).length;
    const showHotelsStep = order.status === OrderStatus.Confirmed;
    const additionalStep = {
        label: t('Hotels'),
        onClick: () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const link = yield oneTwoTripSupplierLink(convertOrderToHotelsSupplierData(offerHotelsLink, order), offerHotelsAdditionalId);
            window.open(link || offerHotelsLink, '_blank');
            setLoading(false);
        })
    };
    const alwaysActiveSteps = {};
    const blockedSteps = {};
    Object.keys(props.stepbarConfig).forEach(key => {
        alwaysActiveSteps[key] = Object.assign(Object.assign({}, props.stepbarConfig[key]), { alwaysOpen: true, isHidden: key === 'Payment', onClick: () => {
                close();
                props.stepbarConfig[key].onClick();
            } });
    });
    if (showHotelsStep) {
        Object.keys(props.stepbarConfig).forEach(key => {
            blockedSteps[key] = Object.assign(Object.assign({}, props.stepbarConfig[key]), { onClick: null });
        });
    }
    const renderAdditionalStep = () => {
        return (React.createElement(Step, { key: stepsAmount + 1, id: stepsAmount + 1, step: additionalStep, isPassed: true, isActive: false }));
    };
    return (React.createElement(ThemeProvider, { value: theme },
        React.createElement(ThemeProvider, { value: redefinedTheme },
            React.createElement(Stepbar, Object.assign({}, props, { steps: showHotelsStep ? blockedSteps : props.steps, alwaysShowSteps: true, renderAdditionalStep: showHotelsStep ? renderAdditionalStep : () => React.createElement(React.Fragment, null) })),
            loading && React.createElement(SimpleLoader, null))));
};
export default StepbarWithShoppingCart;
